import React from 'react';

import { Box, FormHelperText, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FieldArray } from 'formik';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import TextFieldFormik from '../../../../../../common/text_field';
import { isEmptyObject } from '../../../../../../../core/utils/misc_utils';

const ProductsList = ({ formik }) => {
    const onRemoveProduct = (position) => {
        const positions = formik?.values?.positions;
        const index = positions?.findIndex(product => product?.position === position);

        if (index !== -1) {
            positions.splice(index, 1);
            formik.setFieldValue('positions', positions);
        }
    };

    return (
        <FieldArray
            name={ 'positions' }
            render={ () => (
                <Box sx={ { display: 'flex', flexDirection: 'column', gap: 1 } }>
                    <TableContainer component={ Paper } variant="outlined">
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                                    <TableCell sx={ { width: '5%', textAlign: 'center' } }>Lp.</TableCell>
                                    <TableCell>Nazwa</TableCell>
                                    <TableCell align="center" sx={ { width: '150px' } }>Liczba szt.</TableCell>
                                    <TableCell align="right" sx={ { width: '60px', pr: 3 } }>Usuń</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    formik?.values?.positions?.length > 0 ? (
                                        formik.values.positions.map((product, index) => (
                                            <TableRow key={ index } hover>
                                                <TableCell align="center"
                                                           sx={ { fontWeight: 500 } }>{ index + 1 }</TableCell>
                                                <TableCell>
                                                    <TextFieldFormik
                                                        name={ `positions.${ index }.name` }
                                                        size="small"
                                                        disabled
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextFieldFormik
                                                        name={ `positions.${ index }.quantity` }
                                                        type="number"
                                                        size="small"
                                                        inputProps={ { min: '1', step: '1' } }
                                                        sx={ { background: 'white' } }
                                                    />
                                                    {
                                                        !isEmptyObject(formik?.errors?.products?.[index]?.quantity) && (
                                                            <FormHelperText error sx={ { mx: 0, mt: 0.5 } }>
                                                                { formik?.errors?.products?.[index]?.quantity }
                                                            </FormHelperText>
                                                        )
                                                    }
                                                </TableCell>
                                                <TableCell align="right" sx={ { pr: 2 } }>
                                                    <IconButton
                                                        size="small"
                                                        onClick={ () => onRemoveProduct(product?.position) }
                                                        title="Usuń pozycję">
                                                        <RemoveCircleOutlineIcon fontSize="small"/>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={ 4 } align="center"
                                                       sx={ { py: 4, color: 'text.secondary' } }>
                                                Brak dodanych produktów
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {
                        !isEmptyObject(formik?.errors?.positions) && typeof formik?.errors?.positions === 'string' && (
                            <FormHelperText error sx={ { mx: 1, fontSize: '0.875rem' } }>
                                { formik.errors.positions }
                            </FormHelperText>
                        )
                    }
                </Box>
            ) }
        />
    );
};

export default ProductsList;